export const SearchVolopRefinement = {
  ACTION_DATE: 'actionDate',
  ACTION_TYPE: 'actionType', // @NOTE: actionType is deprecated and will eventually be removed
  AREAS_OF_FOCUS: 'areasOfFocus',
  FUNCTIONS: 'functions',
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  RADIUS: 'radius',
  ORG_TYPE: 'orgType',
  SOURCE: 'source',
  RECENCY: 'recency',
} as const;

export const SEARCH_VOLOP_REFINEMENT_NAMES = Object.values(
  SearchVolopRefinement,
);

export type SearchVolopRefinementType =
  (typeof SearchVolopRefinement)[keyof typeof SearchVolopRefinement];

export const SEARCH_VOLOP_REFINEMENT_LABELS = Object.defineProperties(
  {},
  {
    [SearchVolopRefinement.AREAS_OF_FOCUS]: {
      get: () => getText('Cause Areas'),
      enumerable: true,
    },
    [SearchVolopRefinement.FUNCTIONS]: {
      get: () => getText('Skills'),
      enumerable: true,
    },
    [SearchVolopRefinement.ACTION_DATE]: {
      get: () => getText('Date'),
      enumerable: true,
    },
    [SearchVolopRefinement.LOCALE]: {
      get: () => getText('Listing Language'),
      enumerable: true,
    },
    [SearchVolopRefinement.LOCATION_TYPE]: {
      get: () => getText('Location Type'),
      enumerable: true,
    },
    [SearchVolopRefinement.ORG_TYPE]: {
      get: () => getText('Org Type'),
      enumerable: true,
    },
    [SearchVolopRefinement.SOURCE]: {
      get: () => getText('Source'),
      enumerable: true,
    },
    [SearchVolopRefinement.RADIUS]: {
      get: () => getText('Radius'),
      enumerable: true,
    },
    [SearchVolopRefinement.RECENCY]: {
      get: () => getText('Recency'),
      enumerable: true,
    },
  },
) as Record<SearchVolopRefinementType, string>;
